import { Component, input, OnInit, output, signal } from '@angular/core';
import { IconDefinition } from '@fortawesome/fontawesome-svg-core';

import { UiPalette } from '../../../types/UiPalette.type';

@Component({
  selector: 'eiq-toggle-text-button',
  templateUrl: './toggle-text-button.component.html',
  styleUrls: ['./toggle-text-button.component.scss']
})
export class ToggleTextButtonComponent implements OnInit {
  color = input<UiPalette>('primary');
  disabled = input<boolean>(false);
  icon = input<IconDefinition>();
  iconPosition = input<'left' | 'right'>('left');
  expand = input<'block' | 'full'>('block');
  size = input<'large' | 'medium' | 'small'>('medium');
  testId = input<string>();
  text = input<string>();
  toggleText = input<string>();
  toggleColor = input<UiPalette>('success');
  style = input<'stroked' | 'flat' | 'icon' | 'basic' | 'fab'>('flat');

  clicked = output<void>();

  displayColor$ = signal<UiPalette>(null);
  displayText$ = signal('');

  ngOnInit(): void {
    this.displayColor$.set(this.color());
    this.displayText$.set(this.text());
  }

  onClick(): void {
    setTimeout(() => {
      this.displayColor$.set(this.toggleColor());
      this.displayText$.set(this.toggleText());
    }, 100);

    setTimeout(() => {
      this.displayColor$.set(this.color());
      this.displayText$.set(this.text());
    }, 3000);
    this.clicked.emit();
  }
}
